// extracted by mini-css-extract-plugin
export default {"title":"_46fa561ba6","bld":"_47e77848d2"};